import type {ReactNode} from 'react'

interface PageErrorCodeProps {
    children: ReactNode
    'data-testid'?: string
}

export function PageErrorCode({children, 'data-testid': testId}: PageErrorCodeProps) {
    return (
        <h1 className="text-6xl font-bold tracking-tight" data-testid={testId}>
            {children}
        </h1>
    )
}
